import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'



ReactDOM.createRoot(document.getElementById('root')).render(

  <BrowserRouter>
  <App />
  </BrowserRouter>

)

// // console.log("rootElement.hasChildNodes(): ",rootElement.hasChildNodes())
//   hydrateRoot(<App />, rootElement);
// } else {
//   createRoot(<App />, rootElement);
// }


// root.render(
// );
//   hydrate(<App />, rootElement);
// } else {
//   render(<App />, rootElement);
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
